import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.match.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import keys from 'lodash/keys';
import { stringify } from 'qs';
import * as types from './types';
import fetchSearch from '~/services/search';
export default {
  fetchContent(_ref, _ref2) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref;
      var {
        keyword,
        query,
        withMarketplace
      } = _ref2;
      if (!keyword) {
        commit(types.SET_DESCRIPTION, {
          query: ''
        });
        commit(types.SET_PRODUCTS, {
          products: [],
          total: 0
        });
        commit(types.SET_SUGGESTIONS, {
          suggestions: []
        });
        return;
      }
      var {
        productSearch
      } = yield fetchSearch(_this, keyword, query, withMarketplace);
      if (!productSearch) {
        commit(types.SET_DESCRIPTION, {
          query: keyword
        });
        commit(types.SET_PRODUCTS, {
          products: [],
          total: 0
        });
        commit(types.SET_SUGGESTIONS, {
          suggestions: []
        });
        return;
      }
      var {
        details,
        total,
        products,
        suggestions,
        provider,
        queryID
      } = productSearch;
      commit(types.SET_PROVIDER, provider);
      if (details.redirect) {
        var redirectUrl = "".concat(details.redirect_to);
        var currentQuery = keys(query).length ? "&".concat(stringify(query)) : '';
        if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
          _this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
        } else {
          window.location.href = "".concat(redirectUrl).concat(currentQuery);
        }
        return;
      }

      // For Algolia search results, total isn't present in details
      if (!details.total && total) {
        details.total = total;
      }
      commit(types.SET_DESCRIPTION, _objectSpread(_objectSpread({}, details), {}, {
        queryID
      }));
      commit(types.SET_PRODUCTS, {
        products,
        total
      });
      commit(types.SET_SUGGESTIONS, {
        suggestions
      });
    })();
  },
  appendProducts(_ref3, _ref4) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref3;
      var {
        keyword,
        query,
        withMarketplace
      } = _ref4;
      var {
        productSearch: {
          products
        }
      } = yield fetchSearch(_this2, keyword, query, withMarketplace);
      commit(types.APPEND_PRODUCTS, products);
    })();
  },
  prependProducts(_ref5, _ref6) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref5;
      var {
        keyword,
        query,
        withMarketplace
      } = _ref6;
      var {
        productSearch: {
          products
        }
      } = yield fetchSearch(_this3, keyword, query, withMarketplace);
      commit(types.PREPEND_PRODUCTS, products);
    })();
  }
};